// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChatBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M15.252 15.992a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.875 1.5a10.124 10.124 0 0 1-14.74 9.014l-3.04 1.017a1.875 1.875 0 0 1-2.376-2.375l1.013-3.04a10.125 10.125 0 1 1 19.143-4.616Zm-2.25 0a7.874 7.874 0 1 0-14.693 3.943 1.125 1.125 0 0 1 .094.92l-.931 2.793 2.792-.931a1.124 1.124 0 0 1 .919.094 7.875 7.875 0 0 0 11.82-6.819Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
